"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function combineReducersEnhanced(reducers, asFunction) {
    if (asFunction === void 0) { asFunction = true; }
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for (var i = 0; i < reducerKeys.length; i++) {
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') {
            finalReducers[key] = reducers[key];
        }
        else {
            finalReducers[key] = combineReducersEnhanced(reducers[key]);
        }
    }
    if (!asFunction) {
        return finalReducers;
    }
    var finalReducerKeys = Object.keys(finalReducers);
    return function combination(state, action) {
        if (state === void 0) { state = {}; }
        var hasChanged = false;
        var nextState = {};
        for (var i = 0; i < finalReducerKeys.length; i++) {
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}
exports.combineReducersEnhanced = combineReducersEnhanced;
//# sourceMappingURL=index.js.map